var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('baidu-map',{staticClass:"map",attrs:{"center":{ lng: 120.325674, lat: 31.690783 },"zoom":20}},[_c('bm-marker',{attrs:{"position":{ lng: 120.325674, lat: 31.690783 },"dragging":true,"animation":"BMAP_ANIMATION_BOUNCE"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }